import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useI18n } from '../lib/i18n';
import { PasswordInput } from './ui';

/** Pantalla bloqueante: el usuario debe fijar una nueva contraseña antes de entrar. */
export function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const { t } = useI18n();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit() {
    setErr(null);
    if (pw.length < 8) { setErr(t('fpw.min')); return; }
    if (pw !== pw2) { setErr(t('fpw.mismatch')); return; }
    setBusy(true);
    try {
      await api.post('/api/auth/change-password', { newPassword: pw });
      await refresh();
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Error');
    } finally { setBusy(false); }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 20 }}>
      <div className="card" style={{ maxWidth: 420, width: '100%' }}>
        <h2 className="card-title">{t('fpw.title')}</h2>
        <div className="muted" style={{ fontSize: 'var(--fs-sm)', marginBottom: 14 }}>{t('fpw.subtitle')}</div>
        <label className="field">{t('fpw.new')}
          <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} autoFocus />
        </label>
        <label className="field">{t('fpw.confirm')}
          <PasswordInput value={pw2} onChange={(e) => setPw2(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />
        </label>
        {err && <div className="badge red" style={{ marginBottom: 10 }}>{err}</div>}
        <button className="btn" style={{ width: '100%' }} disabled={busy} onClick={submit}>{busy ? '…' : t('fpw.save')}</button>
        <button className="btn ghost sm" style={{ width: '100%', marginTop: 8 }} onClick={logout}>{t('nav.logout')}</button>
      </div>
    </div>
  );
}
